import { PointType } from '../types';

/**
 * Calculate the distance between pointA and pointB
 */
export default function distanceTo(pointA: PointType, pointB: PointType): number {
  const xDiff = (pointB.x - pointA.x) ** 2;
  const yDiff = (pointB.y - pointA.y) ** 2;

  return Math.sqrt(xDiff + yDiff);
}
